// extracted by mini-css-extract-plugin
export default {"dock":"ChatWidget_dock__IPh6x","slot":"ChatWidget_slot__W1Nod","slot_tucking":"ChatWidget_slot_tucking__umpWd","note":"ChatWidget_note__+1n1D"};